import { render, staticRenderFns } from "./application.vue?vue&type=template&id=70549aab&scoped=true&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"
import style0 from "./application.vue?vue&type=style&index=0&id=70549aab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70549aab",
  null
  
)

export default component.exports